const dlsIconUp = {
  "&::before": {
    "content": "\"\\ead7\""
  }
};

export { dlsIconUp };
